import ActivityMonitorContainer from "app/components/ActivityMonitor/ActivityMonitorContainer";
import Button from "app/storybookComponents/Button";
import { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "utils/redux/hooks";
import {
  getOverallActivitySnapshot,
  selectGetOverallActivitySnapshotStatus,
  selectHasAnyWeeklyCheckinResults,
  selectOverallActivitySnapshotByDateInterval,
} from "../slice";
import { OVERALL_ACTIVITY_TIME_RANGE_OPTIONS } from "../constants";
import { getMonitorPropsFromOverallActivitySnapshot } from "../helpers";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  selectAllCompanyUsersById,
  selectCompanyInfo,
  selectConfigCatFlag,
} from "app/containers/Global/slice";
import { CONFIG_CAT_FLAGS } from "app/components/GlobalNavbar/constants";
import { selectCompanySettings } from "app/containers/AdminConsole/slice";

const OverallActivityCard = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const usersById = useAppSelector(selectAllCompanyUsersById);
  const getOverallActivitySnapshotStatus = useAppSelector(
    selectGetOverallActivitySnapshotStatus
  );
  const overallActivitySnapshotByDateInterval = useAppSelector(
    selectOverallActivitySnapshotByDateInterval
  );
  const weeklyCheckInConfigCatFlag = useAppSelector(
    selectConfigCatFlag(CONFIG_CAT_FLAGS.weeklyCheckIn.savedFlagName)
  );
  const companyInfo = useAppSelector(selectCompanyInfo);
  const hasAnyWeeklyCheckinResults = useAppSelector(
    selectHasAnyWeeklyCheckinResults
  );
  const companySettings = useAppSelector(selectCompanySettings);

  const [overallActivityTimeInterval, setOverallActivityTimeInterval] =
    useState("Past 30 days");

  const overallActivitySnapShot = useMemo(() => {
    const activeKey =
      OVERALL_ACTIVITY_TIME_RANGE_OPTIONS[overallActivityTimeInterval];
    return activeKey ? overallActivitySnapshotByDateInterval[activeKey] : null;
  }, [overallActivitySnapshotByDateInterval, overallActivityTimeInterval]);

  useEffect(() => {
    dispatch(getOverallActivitySnapshot());
  }, [dispatch]);

  const onTagClick = (tag: string) => {
    setOverallActivityTimeInterval(tag);
  };

  const weeklyCheckInTimeInterval = overallActivityTimeInterval
    .split("Past")[1]
    .trim()
    .toLowerCase();

  const userCount = Object.keys(usersById).length;

  return (
    <ActivityMonitorContainer
      title="Overall Activity"
      labelTags={Object.keys(OVERALL_ACTIVITY_TIME_RANGE_OPTIONS)}
      activeTag={overallActivityTimeInterval}
      onTagClick={onTagClick}
      boxPropsOrOverrides={getMonitorPropsFromOverallActivitySnapshot(
        overallActivitySnapShot,
        weeklyCheckInTimeInterval,
        userCount,
        companyInfo?.companyAccountId,
        weeklyCheckInConfigCatFlag,
        hasAnyWeeklyCheckinResults ||
          !!companySettings?.hasCoachBoWeeklyCheckInsEnabled
      )}
      footer={
        <Button
          variant="tertiary-blue"
          onClick={() => {
            navigate("/AdminConsole/Dashboard/Overall Activity");
          }}
          className="activity-monitor-container__footer-button"
        >
          View activity <FontAwesomeIcon icon={["fas", "arrow-right"]} />
        </Button>
      }
      timeInterval={weeklyCheckInTimeInterval}
      isLoading={getOverallActivitySnapshotStatus === "loading"}
      loadingSkeletonCount={3}
      className="overall-activity-card"
    />
  );
};

export default OverallActivityCard;
